import { useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box } from 'reflexbox';

import { Container } from '@treams/treams-ui';

import LearningHeader from '../components/LearningHeader';
import LearningCalendarContainer from './LearningCalendarContainer';
import LearningCourseModal from './LearningCourseModal';
import LearningEventAttendeesModal from './LearningEventAttendeesModal';
import LearningEventEditModalID, {
	LearningEventEditModal as LearningEventCreateModal,
	default as LearningEventEditModal,
} from './LearningEventEditModal';
import LearningEventModal from './LearningEventModal';
import LearningEventProposalsContainer from './LearningEventProposalsContainer';
import LearningEventsContainer from './LearningEventsContainer';
import LearningMyEventsContainer from './LearningMyEventsContainer';

type RouteParams = {
	id: string;
};

export function LearningRouterWithoutSidebar() {
	const location = useLocation();

	const [fetchKey, setFetchKey] = useState(0);

	return (
		<>
			<LearningHeader />

			<Container wide={1180}>
				<Box mt={4}>
					<Switch>
						<Route path="/learning/event/create">
							<LearningEventCreateModal refetch={() => setFetchKey(Math.random())} />
						</Route>

						<Route path="/learning/events/copy?eventID=:eventID">
							{({ match }) =>
								match && <LearningEventEditModalID eventID={match.params.eventID!} copy />
							}
						</Route>

						<Route path="/learning/event/:id/attendees" exact>
							{({ match }) => match && <LearningEventAttendeesModal eventID={match.params.id!} />}
						</Route>

						<Route path="/learning/event/:id/edit" exact>
							{({ match }) => match && <LearningEventEditModal eventID={match.params.id!} />}
						</Route>

						<Route path="/learning/event/:id" exact>
							{({ match }) => match && <LearningEventModal eventID={match.params.id!} />}
						</Route>

						<Route path="/learning/course/:id" exact>
							{({ match }) => match && <LearningCourseModal courseID={match.params.id!} />}
						</Route>
					</Switch>

					<Switch location={location.state?.backgroundLocation ?? location}>
						<Route path="/learning/calendar">
							<LearningCalendarContainer key={fetchKey} />
						</Route>

						<Route path="/learning/me" exact>
							<LearningMyEventsContainer key={fetchKey} />
						</Route>

						<Route path="/learning/proposals" exact>
							<LearningEventProposalsContainer key={fetchKey} />
						</Route>

						<Route path="/learning">
							<LearningEventsContainer key={fetchKey} />
						</Route>
					</Switch>
				</Box>
			</Container>
		</>
	);
}
